/**
 * @generated SignedSource<<8700f7b98b973bf20179023b351c6e4f>>
 * @relayHash 3e9ffc9fee79442f0b9ff240d62d129c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID af18267ab48f95020b15f419a3ce00a3ab0c9dad153b476cb0150e86c37f6b39

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type RecommendedAgentResultsQuery$variables = {
  cloudId: string;
  cloudIdString: string;
  contextAri: string;
  first?: number | null;
  templateProduct?: string | null;
  useJiraRecommended: boolean;
};
export type RecommendedAgentResultsQuery$data = {
  readonly agentStudio_getAllTemplates: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly previewRef: {
          readonly " $fragmentSpreads": FragmentRefs<"TemplateView_StudioBrowseKit">;
        };
        readonly templateRef: {
          readonly " $fragmentSpreads": FragmentRefs<"TemplateCard_StudioBrowseKit">;
        };
      } | null;
    } | null> | null;
  } | null;
  readonly jira?: {
    readonly jira_recommendedAgentsV2: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly agent?: {
            readonly agentRef?: {
              readonly " $fragmentSpreads": FragmentRefs<"AgentCardRelay_StudioBrowseKit">;
            } | null;
            readonly deactivated?: boolean | null;
            readonly heroRef?: {
              readonly " $fragmentSpreads": FragmentRefs<"AgentHeroCard_StudioBrowseKit">;
            } | null;
            readonly id?: string;
          } | null;
        } | null;
      } | null> | null;
    } | null;
  } | null;
};
export type RecommendedAgentResultsQuery = {
  response: RecommendedAgentResultsQuery$data;
  variables: RecommendedAgentResultsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudIdString"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contextAri"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "templateProduct"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "useJiraRecommended"
},
v6 = [
  {
    "kind": "Literal",
    "name": "assignableOnly",
    "value": true
  },
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "contextAri",
    "variableName": "contextAri"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  },
  {
    "kind": "Literal",
    "name": "includeSemanticallyAvailable",
    "value": false
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "id"
},
v8 = {
  "kind": "ScalarField",
  "name": "deactivated"
},
v9 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudIdString"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "product",
    "variableName": "templateProduct"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "ScalarField",
  "name": "name"
},
v12 = {
  "kind": "ScalarField",
  "name": "description"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "RecommendedAgentResultsQuery",
    "selections": [
      {
        "condition": "useJiraRecommended",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "JiraActorConnection",
                "kind": "LinkedField",
                "name": "jira_recommendedAgentsV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraActorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v7/*: any*/),
                                      (v8/*: any*/),
                                      {
                                        "fragment": {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "kind": "FragmentSpread",
                                              "name": "AgentCardRelay_StudioBrowseKit"
                                            }
                                          ],
                                          "type": "AgentStudioAssistant"
                                        },
                                        "kind": "AliasedInlineFragmentSpread",
                                        "name": "agentRef"
                                      },
                                      {
                                        "fragment": {
                                          "kind": "InlineFragment",
                                          "selections": [
                                            {
                                              "kind": "FragmentSpread",
                                              "name": "AgentHeroCard_StudioBrowseKit"
                                            }
                                          ],
                                          "type": "AgentStudioAssistant"
                                        },
                                        "kind": "AliasedInlineFragmentSpread",
                                        "name": "heroRef"
                                      }
                                    ],
                                    "type": "AgentStudioAssistant"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraAgenticUser"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v9/*: any*/),
        "concreteType": "AgentStudioTemplateListResult",
        "kind": "LinkedField",
        "name": "agentStudio_getAllTemplates",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAgentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "TemplateCard_StudioBrowseKit"
                        }
                      ],
                      "type": "AgentStudioAgentTemplate"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "templateRef"
                  },
                  {
                    "fragment": {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "FragmentSpread",
                          "name": "TemplateView_StudioBrowseKit"
                        }
                      ],
                      "type": "AgentStudioAgentTemplate"
                    },
                    "kind": "AliasedInlineFragmentSpread",
                    "name": "previewRef"
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "RecommendedAgentResultsQuery",
    "selections": [
      {
        "args": (v9/*: any*/),
        "concreteType": "AgentStudioTemplateListResult",
        "kind": "LinkedField",
        "name": "agentStudio_getAllTemplates",
        "plural": false,
        "selections": [
          {
            "concreteType": "AgentStudioTemplateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "AgentStudioAgentTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "avatarUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "usageCount"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "templateAppKeys"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "category"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "tags"
                  },
                  {
                    "concreteType": "AgentStudioAgentTemplateSupportedTrigger",
                    "kind": "LinkedField",
                    "name": "supportedTriggers",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "key"
                      },
                      (v11/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "AgentStudioAgentTemplateHowItWorksStep",
                    "kind": "LinkedField",
                    "name": "howItWorks",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "role"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "text"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "condition": "useJiraRecommended",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
              {
                "args": (v6/*: any*/),
                "concreteType": "JiraActorConnection",
                "kind": "LinkedField",
                "name": "jira_recommendedAgentsV2",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraActorEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "agent",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v7/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v8/*: any*/),
                                      (v11/*: any*/),
                                      (v12/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "isVerified"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "isFavourite"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "icon"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "externalConfigReference"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "identityAccountId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "identityAccount",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          {
                                            "kind": "TypeDiscriminator",
                                            "abstractKey": "__isUser"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "picture"
                                          },
                                          {
                                            "kind": "InlineFragment",
                                            "selections": [
                                              {
                                                "kind": "ScalarField",
                                                "name": "appType"
                                              }
                                            ],
                                            "type": "AppUser"
                                          },
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "creatorType"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "forgeCreator"
                                      },
                                      {
                                        "concreteType": "TeamV2",
                                        "kind": "LinkedField",
                                        "name": "authoringTeam",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "displayName"
                                          },
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "creator",
                                        "plural": false,
                                        "selections": [
                                          (v10/*: any*/),
                                          (v11/*: any*/),
                                          (v7/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ClientExtension",
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "__id"
                                          }
                                        ]
                                      }
                                    ],
                                    "type": "AgentStudioAssistant"
                                  }
                                ]
                              }
                            ],
                            "type": "JiraAgenticUser"
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "af18267ab48f95020b15f419a3ce00a3ab0c9dad153b476cb0150e86c37f6b39",
    "metadata": {},
    "name": "RecommendedAgentResultsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "63bd15eec3c1fb036e9321887e414838";

export default node;
